<template>
	<div>
		<div class="title-container">
			<div class="title">Update Filter</div>
			<div class="buttons">
				<router-link :to="{ name: 'module-filters-page', params: $route.params }" exact class="button"><div class="hover-title">Cancel</div><span class="fa fa-times"></span></router-link>
			</div>
		</div>

		<form ref="form" method="post" @submit.prevent="onSubmit">
			<form-errors :errors="errors"></form-errors>

			<field-errors v-if="submitAttempted" :form="$v.form" field="name"></field-errors>
			<div class="input-container">
				<div class="input-title">Filter Name</div>
				<div class="input-box"><input v-model="form.name" type="text"></div>
			</div>

			<advanced-filters
				:module="module"
				:loading-state="{ state: 'LOADED' }"
				:has-filters="(form.filters || []).length"
				:filtered-count="null"
				:manage="true"
				v-model="form">
			</advanced-filters>

			<!-- TODO: Specify color. Have a 'custom' option that displays the color picker too. -->
			<!--			<field-errors v-if="submitAttempted" :form="$v.form" field="color"></field-errors>-->
			<!--			<div class="input-container">-->
			<!--				<div class="input-title">Color</div>-->
			<!--				<div class="input-box">-->
			<!--					<selectize v-model="form.color" :settings="{ create: false }">-->
			<!--						<option value="good">Good</option>-->
			<!--						<option value="bad">Bad</option>-->
			<!--						<option value="neutral">Neutral</option>-->
			<!--					</selectize>-->
			<!--				</div>-->
			<!--			</div>-->

			<submit-button text="Save Module Filter" icon="fa-save" :has-errors="hasErrors" :loading="formSaving"></submit-button>
		</form>
	</div>
</template>

<script>

import FormMixin from '@/mixins/FormMixin';
import { required } from 'vuelidate/lib/validators';
import AdvancedFilters from '@/views/sections/app/modules/components/filters/AdvancedFilters';

export default {

	mixins: [FormMixin],

	name: 'ModuleFiltersUpdatePage',

	async asyncData({ app, route }) {
		const filter = await app.$api.get(`/module/${ route.params.slug }/filters/${ route.params.filterId }/edit`);
		const { data } = await app.$api.get(`/module/${route.params.slug}/list`);

		return {
			form: filter.data.data,
			module: data.module,
		};
	},

	data() {
		return {
			form: {},
			module: {},
		};
	},

	validations: {
		form: {
			filters: { required },
			name: { required },
		},
	},

	methods: {

		async onSubmit() {
			this.submit(async () => {
				await this.$api.put(`/module/${ this.$route.params.slug }/filters/${ this.form.id }`, this.form);

				this.$store.dispatch('addToast', 'Module Filter Updated');
				this.$router.back();
			}, (e) => {
				this.$store.dispatch('errorToast', 'Unable to save filter: ' + e.message);
			});
		},

	},

	components: {
		AdvancedFilters,
	},
};

</script>
